import styles from './index.module.less'
import { Avatar, Badge, Col, Row } from 'antd'
import classNames from 'classnames'
import { getImageUrl } from '@/utils/image.ts'
import { UserOutlined } from '@ant-design/icons';
export default function ChatItem(props) {
  const { data, onClick, active, urlPrefix, unReadCount, hideBadge } = props
  return (
    <div className={classNames(styles.chatItem, { [styles.active]: active })} onClick={onClick}>
      <Row gutter={12} align="middle" wrap={false}>
        <Col style={{ flexShrink: 0 }}>
          {/*<div className={styles.chatItemIcon}></div>*/}
          <Badge count={hideBadge ? 0 : unReadCount}>
            <Avatar src={getImageUrl(data.avatarUrl, urlPrefix)} size={36} icon={<UserOutlined />}  />
          </Badge>
        </Col>
        <Col flex={1}>
          <Row justify="space-between" align="middle">
            <Col className={styles.chatName}>{data.name}</Col>
            <Col className={styles.chatTime}>{data.time}</Col>
          </Row>
          <div className={styles.chatDescription}>{data.summary}</div>
        </Col>
      </Row>
    </div>
  )
}
